export default [
  {
    prop: 'wlbm',
    label: '物料编码',
  },
  {
    prop: 'pc',
    label: '批次号',
  },
  {
    prop: 'wlms',
    label: '物料描述',
    width: 160,
  },
  {
    prop: 'gysmc',
    label: '供应商',
  },
  {
    prop: 'dddw',
    label: '订单单位',
    isTemplate: true
  },
  {
    prop: 'remarks',
    label: '备注',
    isTemplate: true,
    width: 140,
    align: 'center',
  },
  //连云港
  {
    prop: 'storageLocationProject',
    label: '库位',
    isTemplate: true,
    width: 140,
    align: 'center',
  },
  {
    prop: 'materialsNum',
    label: '物资数量',
    isTemplate: true,
    width: 150,
    align: 'center',
  },
  //托盘
  // {
  //   prop: 'stock',
  //   label: '托盘号',
  //   isTemplate: true,
  //   width: 140,
  //   align: 'center',
  // },
  // {
  //   prop: 'date',
  //   label: '日期',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'numberDisks',
  //   label: '组盘数量',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'quantityIssued',
  //   label: '发出数量',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'balanceQuantity',
  //   label: '结存数量',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  //吉祥路
  // {
  //   prop: 'date',
  //   label: '日期',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'numberDisks',
  //   label: '入库数量',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'quantityIssued',
  //   label: '出库数量',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'balanceQuantity',
  //   label: '库存数量',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  //电缆
  // {
  //   prop: 'shippingSpace',
  //   label: '仓位号',
  //   isTemplate: true,
  //   width: 140,
  //   align: 'center',
  // },
  // {
  //   prop: 'factoryCode',
  //   label: '出厂编码',
  //   isTemplate: true,
  //   width: 140,
  //   align: 'center',
  // },
  // {
  //   prop: 'date',
  //   label: '日期',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'numberDisks',
  //   label: '组盘长度',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'quantityIssued',
  //   label: '发出数量',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  // {
  //   prop: 'balanceQuantity',
  //   label: '结存长度',
  //   isTemplate: true,
  //   width: 150,
  //   align: 'center',
  // },
  //标签数量
  {
    prop: 'copies',
    label: '标签数量',
    fixed: 'right',
    isTemplate: true,
    width: 150,
    align: 'center'
  },
]
